import React, { useState } from "react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch("/api/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    setMessage(data.message || "Se o e‑mail existir, você receberá instruções.");
  };

  return (
    <div className="forgot-password-container">
      <h2>Esqueci minha senha</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="E‑mail cadastrado"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Enviar link de recuperação</button>
      </form>
      {message && <p className="info-message">{message}</p>}
    </div>
  );
}
